import Vue from 'vue'
import App from './app/App.vue'

import Ionic from "@modus/ionic-vue"
import VueClipboard from 'vue-clipboard2'
import { GridPlugin } from '@syncfusion/ej2-vue-grids';
import vuetify from '@/plugins/vuetify'
import "@ionic/core/css/core.css"
import "@ionic/core/css/ionic.bundle.css"
import "./app/app.scss"
import "@syncfusion/ej2-icons/styles/material.css"
import "@syncfusion/ej2-vue-grids/styles/material.css"

import router from './router'
import store from './state'
import './filters'
import './mixins'

Vue.config.productionTip = false
Vue.use(Ionic)
Vue.use(VueClipboard)
Vue.use(GridPlugin)

new Vue({
  render: h => h(App),
  router,
  store,
  vuetify
}).$mount('#app')